module.exports = __webpack_public_path__ + "img/hu2.562f050d.png";